import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PUBLIC_ROUTE_PREFIXES } from './public-route-prefixes';

const matchesRoutePrefix = (url: string, prefix: string): boolean =>
  url === prefix || url.startsWith(`${prefix}/`);

export const lerLandingPageRedirectGuard: CanActivateFn = (_, state) => {
  const userApi = inject(AccredibleUserApiService);
  const router = inject(Router);

  const user = userApi.getUser();

  if (user?.ler_profile?.ler_terms_accepted) {
    return router.createUrlTree(['/dashboard']);
  }

  const isPublicContentRoute = PUBLIC_ROUTE_PREFIXES.some((prefix) =>
    matchesRoutePrefix(state.url, prefix),
  );

  if (user?.ler_profile && !user.ler_profile.ler_terms_accepted && !isPublicContentRoute) {
    return router.createUrlTree(['/accept-terms']);
  }

  return true;
};
